import { render, staticRenderFns } from "./SettingsCreateRole.vue?vue&type=template&id=ec6b86a2&scoped=true"
import script from "./SettingsCreateRole.vue?vue&type=script&lang=js"
export * from "./SettingsCreateRole.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateRole.vue?vue&type=style&index=0&id=ec6b86a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6b86a2",
  null
  
)

export default component.exports